export default __webpack_public_path__ + "static/media/vscode.f30433c9.svg";